import { useTheme } from '../contexts/ThemeProvider';
import { MainTemplate } from '../templates/MainTemplate';
import { HomeWithClub } from './Home/HomeWithClub';

export function HomePage() {
  const { banners, id, name, openModalLogin, customerCentralModule } = useTheme();

  return (
    <MainTemplate>
      <HomeWithClub
        banners={banners}
        id={id || ''}
        name={name || ''}
        openModalLogin={openModalLogin}
        customerCentralModule={customerCentralModule || false}
      />
    </MainTemplate>
  );
}
